import {
  tokens,
  makeStyles,
  shorthands,
  typographyStyles,
} from '@fluentui/react-components';
import bannerBackground from '../../image-asset/banner-background.png';

export const useBannerContainerStyles = makeStyles({
  bannerContainer: {
    width: '100%',
    display: 'flex',
    alignSelf: 'stretch',
    flexDirection: 'column',
    ...shorthands.padding('36px'),
    ...shorthands.borderRadius(tokens.borderRadiusXLarge),
    ...shorthands.gap(tokens.spacingVerticalXXL, tokens.spacingHorizontalXXL),
    backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8)), url(${bannerBackground})`,
    backgroundSize: 'cover',
    'background-position': 'right center',
    backgroundRepeat: 'no-repeat',
    ...typographyStyles.body1,
  },
  heading: {
    marginBlockEnd: tokens.spacingVerticalS,
  },
});
